module.exports = __webpack_public_path__ + "media/images/photography/find-your-cm-c3039f5a7afefdc20128694363b5feaf.jpg";